export const setGlobalLineHeight = (language) => {
  const lineHeight = getComputedStyle(window.root).getPropertyValue(
    `--line-height-${language}`
  );
  window.root.style.setProperty('--global-line-height', lineHeight);
};
